import Layout from "../../layouts/Layout";
import { connect } from "react-redux";
import React, { useState, useCallback, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { toast } from "react-hot-toast";
import { FaDownload, FaHome, FaListUl, FaPhone, FaPhoneAlt } from "react-icons/fa";
import CopyToClipboard from "react-copy-to-clipboard";
import { useRouter } from "next/router";
import OrderDownloadPopup from "../../components/checkout/OrderDownloadPopup";
import Preloader from "../../components/Preloader";
import { gtmThankYouPage } from "../../lib/google-tag-manager";
import { resetCart } from "../../redux/actions/cartAction";
import { saveCart } from "../../lib/cart";
import { setLayer } from "../../redux/actions/globalAction";
import Slider from "react-slick";
import { isMobile } from "react-device-detect";
import MobileThankYouPage from "../../components/checkout/MobileThankYou";
import ServiceSteps from "pages/checkout/ServiceSteps";

const ThankYou = ({ apiData, cart, globalData, loginData, resetCart, setLayer }) => {
    const router = useRouter();
    const [orderData, setOrderData] = useState(cart.orderSuccess);
    const [orderInfoData, setOrderInfoData] = useState();
    const [quoteData, setQuoteData] = useState(null);
    const [showDownloadPopup, setShowDownloadPopup] = useState(false);

    const [orderNumber, setOrderNumber] = useState("");

    useEffect(() => {
        saveCart(cart, apiData, globalData, true);
        resetCart()
        setLayer(false)
    }, [])


    const [mounted, setMounted] = useState(false);

    const SERVICE_CATEGORIES = {
        UPFRONT_PRICE_BASED: "UPFRONT PRICE BASED",
        MOBILE_MECHANIC_BASED: "MOBILE MECHANIC BASED",
        PACKAGES_BASED: "PACKAGES BASED",
        QUOTE_BASED: "QUOTE BASED"
    };

    const [selectedService, setSelectedService] = useState(
        SERVICE_CATEGORIES.UPFRONT_PRICE_BASED
    );

    const serviceCategories = {
        [SERVICE_CATEGORIES.UPFRONT_PRICE_BASED]: [
            "oil-change",
            "ac-service",
            "inspection",
            "car-care",
        ],
        [SERVICE_CATEGORIES.MOBILE_MECHANIC_BASED]: [
            "mobile-mechanic",
            "breakdown",
            "car-wash-at-home",
        ],
        [SERVICE_CATEGORIES.PACKAGES_BASED]: [
            "service-contract",
            "repair",
            "tires-wheels",
            "battery",
        ],
    };

    const handleSelectedService = () => {
        const service = localStorage.getItem("selected-service");
        serviceCategories[SERVICE_CATEGORIES.UPFRONT_PRICE_BASED].map((item) => {
            if (item == service) {
                setSelectedService([SERVICE_CATEGORIES.UPFRONT_PRICE_BASED]);
            }
            return item;
        });
        serviceCategories[SERVICE_CATEGORIES.MOBILE_MECHANIC_BASED].map((item) => {
            if (item == service) {
                setSelectedService(SERVICE_CATEGORIES.MOBILE_MECHANIC_BASED);
            }
            return item;
        });
        serviceCategories[SERVICE_CATEGORIES.PACKAGES_BASED].map((item) => {
            if (item == service) {
                setSelectedService(SERVICE_CATEGORIES.PACKAGES_BASED);
            }
            return item;
        });
        if (service == 'quote') {
            setSelectedService(SERVICE_CATEGORIES.QUOTE_BASED)
        }
    };

    useEffect(() => {
        gtmThankYouPage()
        const hasVisited = localStorage.getItem('hasVisitedRoute');
        if (!hasVisited) {
            router.push("/")
        } else {
            setMounted(true)
        }
        return () => {
            localStorage.removeItem("hasVisitedRoute");
            localStorage.removeItem("SosUser");
        }
    }, [])


    const handleShareClick = () => {
        if (navigator.share) {
            navigator
                .share({
                    title: "Try Open Bonnet",
                    text: `Checkout more about open bonnet`,
                    url: "https://openbonnet.com",
                })
                .then(() => {
                    console.log("Successfully shared");
                })
                .catch((error) => {
                    console.error("Something went wrong sharing the blog", error);
                });
        }
    };

    const getUser = () => {
        if (typeof localStorage !== 'undefined') {
            const Data = JSON.parse(localStorage.getItem("SosUser") || JSON.stringify(""));
            return Data.FirstName || "";
        }
    }

    const Data = [
        "Lead Submitted",
        "OB Service Advisors will contact you within 2 working hours",
        "Your job appointment will be created in system",
        "OB Service Advisor will supervise the job to ensure Quality & correct Prices",
    ];

    const id = Data?.length;

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    if (!mounted)
        return <Preloader />

    return (
        <Layout title={"Request Submission Confirmation"} locationOn={true}>
            <Container
                fluid
                className="text-center thank-you"
                style={{ marginTop: 80 }}
            >
                <Row className="thank-you-bg justify-content-center align-items-center">
                    <img src="/assets/thank-you-man.svg" alt="thank-you-man" height={220} />
                </Row>
                <Row style={{ marginTop: "20px" }}>
                    <Col>
                        <h1>Thank You{getUser() ? "," : "!"} {getUser()} </h1>
                        <h5>We Will Contact You Shortly!</h5>
                    </Col>
                </Row>
                <Row className="d-flex justify-content-center mt-5 service-content">
                    <Col md={10}>
                        <p className="text-black thankyou-service-content">
                            Your <strong>Lead Submission Details</strong> have been received by our service advisor.
                        </p>

                    </Col>
                </Row>
                <Row style={{ marginTop: "30px" }}>
                    <Col>
                        <p className="text-black font-weight-bold">
                            Here’s what will happen next on Open Bonnet:
                        </p>
                    </Col>
                </Row>
                <Row></Row>
                <div className="thank-you-page-checkout">
                    <div className="stages-block">
                        <ServiceSteps
                            steps={
                                selectedService == SERVICE_CATEGORIES.MOBILE_MECHANIC_BASED
                                    ? [
                                        "Mobile Mechanic Order Placed",
                                        "Crew Reaches your location as per agreed schedule",
                                        "Selected service will be performed by crew",
                                        "Any additional work will be discussed with you by OB service Advisor",
                                        "Only after your approval, any additional work will be done",
                                        "Job completed & crew departs",
                                        "Your Mobile Mechanic Job is backed by the “OB Assure” Promise",
                                    ]
                                    : selectedService ==
                                        SERVICE_CATEGORIES.UPFRONT_PRICE_BASED
                                        ? [
                                            "Service Order Placed",
                                            "Car Reaches Workshop as Per Schedule",
                                            "Workshop services & inspects your car",
                                            "OB Service Advisor inspects your car & reviews any additional estimate",
                                            "Only after your approval, any additional work will be done",
                                            "OB Service Advisor does final quality check",
                                            "Car Ready for delivery/ collection",
                                            "Your Service is backed by the “OB Assure” Promise",
                                        ]
                                        : selectedService == SERVICE_CATEGORIES.PACKAGES_BASED
                                            ? [
                                                "Package Purchased Successfully",
                                                "Redemption of Services can be requested anytime as per Package Validity",
                                                "OB Service Advisor will assist you in scheduling your services",
                                                "Your Package is backed by the “OB Assure” Promise",
                                            ]
                                            : [
                                                "Quote Request Created",
                                                "OB Partner Workshops receive your Quote Request instantly ",
                                                "Workshops expected to submit Quotes within next 48 hours",
                                                "Open Bonnet reviews & recommends best Quotes for your needs",
                                                "You can select a Quote of your liking anytime after its received",
                                                "Your job will be created at the Workshop that raised the selected Quote",
                                                "OB Service Advisor will supervise the job to ensure Quality & correct Prices",
                                            ]
                            }
                        />
                    </div>
                    <div className="ds-orange-block">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="ds-ref-tp-block">
                                    <h3>
                                        Reccommend <label>Open Bonnet</label> &amp; Get Rewarded
                                    </h3>
                                    <p>
                                        You &amp; your friend each get AED 25 worth OB CashPoints!
                                    </p>
                                </div>
                                <div className="d-flex cs-gp-shr">
                                    <div className="ds-ref-code-bl">
                                        <label>
                                            <small>Your Referral Code:</small>
                                            <input
                                                style={{ border: "none" }}
                                                type="text"
                                                placeholder={
                                                    loginData?.userAuth?.PhoneNumber
                                                        ? "0" + loginData?.userAuth?.PhoneNumber
                                                        : ""
                                                }
                                                aria-label="Recipient's username"
                                                aria-describedby="basic-addon2"
                                                disabled
                                            />
                                        </label>
                                        <p
                                            onClick={() => {
                                                navigator.clipboard.writeText(
                                                    `${"0" + loginData.userAuth?.PhoneNumber}`
                                                );
                                                toast.dismiss();
                                                toast.success("Referral Code Copied!");
                                            }}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={13}
                                                height={14}
                                                viewBox="0 0 13 14"
                                                fill="none"
                                            >
                                                <path
                                                    d="M9.25 10.3333V12.3333C9.25 12.5101 9.17757 12.6797 9.04864 12.8047C8.9197 12.9298 8.74484 13 8.5625 13H1.6875C1.50516 13 1.3303 12.9298 1.20136 12.8047C1.07243 12.6797 1 12.5101 1 12.3333V4.33333C1 4.15652 1.07243 3.98695 1.20136 3.86193C1.3303 3.7369 1.50516 3.66667 1.6875 3.66667H3.75M4.4375 1H11.3125C11.6922 1 12 1.29848 12 1.66667V9.66667C12 10.0349 11.6922 10.3333 11.3125 10.3333H4.4375C4.0578 10.3333 3.75 10.0349 3.75 9.66667V1.66667C3.75 1.29848 4.0578 1 4.4375 1Z"
                                                    stroke="#0F8514"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                            <span>Copy</span>
                                        </p>
                                    </div>
                                    <div className="share-action" onClick={handleShareClick}>
                                        <span>Share Now</span>
                                    </div>
                                </div>
                                <p className="ds-cpy-txt">
                                    Copy &amp; Share with friends to use for Sign Up
                                </p>
                            </div>
                            <div className="col-md-4">
                                <div className="ds-friends-image">
                                    <img src="/assets/friends.webp" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {/* <Row className="d-flex justify-content-center mt-5">
                    <Col md={10}>
                        <div id="button-request-mobile">
                            <button style={!isMobile ? {
                                width: "152px",
                                height: "45px"
                            } : {}} onClick={() => router.push("/")} className="cta mr-2">
                                <FaHome style={{
                                    marginBottom: "3px"
                                }} /> Home
                            </button>
                            <button style={!isMobile ? {
                                width: "152px",
                                height: "45px"
                            } : null} className="cta mr-2">
                                <a
                                    className="center-header whatsapp d-flex justify-content-center"
                                    href="tel:8002274357"
                                    target="_blank"
                                    style={{ color: "white" }}
                                >
                                    <FaPhoneAlt style={{
                                        marginBottom: "3px", marginRight: "3px"
                                    }} /> Contact OB</a>
                            </button>
                        </div>
                    </Col>

                    <OrderDownloadPopup
                        jobReference={orderData?.OrderNumber || orderNumber}
                        show={showDownloadPopup}
                        onHide={() => {
                            console.log("WORKING")
                            setShowDownloadPopup(false);
                        }}
                    />
                </Row> */}
            </Container>
        </Layout >
    );
};

const mapStateToProps = (state) => {
    return {
        apiData: state.apiData,
        globalData: state.globalData,
        loginData: state.loginData,
        cart: state.cart,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        resetCart: () => {
            dispatch(resetCart())
        },
        setLayer: (status) => {
            dispatch(setLayer(status))
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ThankYou);